import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class EventService {

  private authenticationStatus = new BehaviorSubject({status: false});
  private userInfo = new Subject();

  public isUserLoggedIn = false;

  onAuthenticationStatusChange(status: boolean) {
    this.authenticationStatus.next({status: status});
  }

  getAuthenticationStatus(): Observable<any> {
    return this.authenticationStatus.asObservable();
  }

  onUserInfoChange(user: Object) {
    this.userInfo.next({user: user});
  }

  getUserInfo(): Observable<any> {
    return this.userInfo.asObservable();
  }
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/services/event.service.ts